import { render } from "./submissions-modal.vue?vue&type=template&id=7ec19a80&ts=true"
import script from "./submissions-modal.vue?vue&type=script&lang=ts"
export * from "./submissions-modal.vue?vue&type=script&lang=ts"

import "./submissions-modal.vue?vue&type=style&index=0&id=7ec19a80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__